import request from '@/utils/request';
//类型获取
export function pageType() {
  return request.post('admin/dynamic-controls/get-page-type', {});
}
//列表
export function addDynamicControl(data) {
  return request.post('admin/dynamic-controls/store', data);
}

//新增
export function dynamicControlList(data) {
  return request.post('admin/dynamic-controls/list', data);
}

//编辑
export function editDynamicControl(data) {
  return request.post('admin/dynamic-controls/edit', data);
}

//详情
export function dynamicControlDetail(data) {
  return request.post('admin/dynamic-controls/detail', data);
}

//修改状态;
export function dynamicControlStatus(data) {
  return request.post('admin/dynamic-controls/edit-status', data);
}

//配置模板;
export function dynamicControlSetConfig(data) {
  return request.post('admin/dynamic-controls/set-config', data);
}
//获取控件组件资源(配置页面需要)
export function getDynamicResources(data) {
  return request.post('admin/template/group/dynamic', data);
}